import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './translations/en.json';
import ltTranslation from './translations/lt.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      lt: {
        translation: ltTranslation
      }
    },
    lng: 'lt', // Set Lithuanian as default language
    fallbackLng: 'lt',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false // React already safes from XSS
    }
  });

export default i18n;
